module.exports = __webpack_public_path__ + "img/bg_flower_shop.2129e50e.jpg";